const INTERNAL_EMAIL_DOMAINS = ["rivetai.com"] as const;

export const isInternalAnalyticsUser = (email: string | undefined): boolean => {
  if (!email?.includes("@")) {
    return false;
  }

  const domain = email.split("@")[1]?.trim().toLowerCase();
  return domain
    ? INTERNAL_EMAIL_DOMAINS.includes(domain as (typeof INTERNAL_EMAIL_DOMAINS)[number])
    : false;
};
